<template>
    <el-card>
        <el-row class="trainVideo__title">培训视频配置</el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="培训视频配置" name="first">
                <trainVideoConfig />
            </el-tab-pane>
            <el-tab-pane label="培训视频分类" name="second">
                <trainVideoSort />
            </el-tab-pane>
        
        </el-tabs>
    </el-card>
</template>
<script>
import trainVideoSort from './trainVideoSort.vue'
import trainVideoConfig from './trainVideoConfig.vue'
export default {
    components: {
        trainVideoSort,
        trainVideoConfig
    },
    data() {
        return {
            activeName: 'first'
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event)
        }
    }
}
</script>
<style scoped lang="scss">
.trainVideo {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

    }
}
</style>